export default __webpack_public_path__ + "static/media/flexicuiot.0cb7bcd5.jpeg";